module.exports = __webpack_public_path__ + "static/media/group4.807a391b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4.svg
// module id = 1357
// module chunks = 0